import ServicePage from "../components/ServicePage";

export default function WebDesignNovara() {
  return (
    <ServicePage
      seo={{
        title: "Web Design a Novara | Design di Siti Web su Misura — Lumora",
        description:
          "Web design a Novara: siti veloci, eleganti e pensati per convertire visitatori in clienti. Niente template: ogni progetto è disegnato su misura. Scopri come lavoriamo.",
        path: "/web-design-novara",
      }}
      kicker="Web design · Novara"
      h1="Web design a Novara che fa la differenza"
      lead="Un sito bello non basta: deve ispirare fiducia in tre secondi e guidare il visitatore verso il contatto. Come studio di web design a Novara, uniamo estetica editoriale e concretezza commerciale: tipografia curata, spazi generosi, contenuti chiari e percorsi che portano a scriverti o chiamarti."
      features={[
        "Design su misura, mai template: partiamo dalla tua identità, dai tuoi colori e da come parli ai tuoi clienti.",
        "Esperienza mobile perfetta: il sito si adatta a ogni schermo e resta leggibile e veloce anche da telefono.",
        "Struttura pensata per vendere: ogni pagina ha un obiettivo chiaro — contatto, prenotazione o preventivo.",
        "Tipografia e dettagli di livello editoriale, perché la cura si vede e si percepisce.",
        "Micro-animazioni e transizioni misurate che rendono il sito vivo senza appesantirlo.",
        "Accessibilità e leggibilità rispettate: testi chiari, contrasti corretti, navigazione semplice per tutti.",
      ]}
      priceTitle="Il design è incluso nella creazione, da €1.000"
      priceDesc="Non vendiamo il design come voce separata: è il cuore della creazione del sito. Ogni progetto include bozza grafica, revisioni condivise e una demo da provare prima del lancio, così vedi esattamente cosa stai comprando."
      faqs={[
        {
          q: "Posso vedere come sarà il sito prima di decidere?",
          a: "Sì. Prepariamo sempre una demo navigabile che puoi vedere e provare prima del lancio: niente sorprese, approvi tu ogni scelta importante.",
        },
        {
          q: "Ho già un logo e dei colori aziendali, li usate?",
          a: "Certo: partiamo dalla tua identità esistente e la portiamo sul web. Se non ce l'hai ancora, possiamo curare anche quella.",
        },
        {
          q: "Il sito sarà visibile bene anche da cellulare?",
          a: "Sì, progettiamo prima per lo smartphone e poi per gli schermi grandi, perché la maggior parte dei tuoi clienti ti trova da mobile.",
        },
      ]}
      related={[
        { path: "/creazione-siti-web-novara", label: "Creazione siti web a Novara" },
        { path: "/seo-novara", label: "SEO a Novara" },
        { path: "/gestione-siti-web", label: "Gestione siti web" },
      ]}
    />
  );
}
